import { defineStore } from "pinia";
import {
  TrainingConfig,
  TrainingHistoryRequest,
  TrainingResult,
} from "@/interface/training";
import { Sequential } from "@tensorflow/tfjs";
import {
  addLearningLog,
  addTrainingHistory,
  deleteTrainingHistory,
  getTrainingHistory,
} from "@/api/learning";
import { LOG_TYPE } from "@/interface/learning";

interface trainingState {
  training: boolean;
  trained: boolean;
  model: Sequential | null;
  config: TrainingConfig;
  history: TrainingResult[];
  enableAdvancedSettings: boolean;
}

export const useTrainingStore = defineStore("training", {
  state: (): trainingState => {
    return {
      training: false,
      trained: false,
      model: null,
      config: {
        datasetId: null,
        modelId: null,
        optimizer: "adam",
        learningRate: 3, // 0.1 ** 3 = 0.0001
        batchSize: 9, // 2 ** 9 = 512
        epochs: 3,
      },
      history: [],
      enableAdvancedSettings: false,
    };
  },
  actions: {
    getUserTrainingHistory() {
      getTrainingHistory().then((res) => {
        this.history = res.data;
      });
    },
    addTrainingHistory(result: TrainingHistoryRequest) {
      addTrainingHistory(result).then((res) => {
        const data: TrainingResult = res.data;
        this.history.push(data);

        return addLearningLog({
          log_type: LOG_TYPE.train_model,
          log: {
            modelId: data.config.modelId,
            datasetId: data.config.datasetId,
            evalAcc: data.evaluate_accuracy,
          },
        });
      });
    },
    deleteTrainingHistoryByIndex(index: number) {
      deleteTrainingHistory(this.history[index].id).then(() => {
        return addLearningLog({
          log_type: LOG_TYPE.delete_result,
          log: { resultId: this.history[index].id },
        }).then(() => {
          this.history.splice(index, 1);
        });
      });
    },
  },
});
